
export const addNewBooking = async ( firebase, uid, cartData, locations, dateTimes, { jobReferenceNumber, crewSize, notes = '', roleProductionCompany } ) => {

  try {
    const booking_data = {
      jobReferenceNumber: jobReferenceNumber,
      roleProductionCompany: roleProductionCompany,
      crewSize: crewSize,
      notes: notes,
      services: [ ...cartData ],
      locations: locations,
      dateTimes: dateTimes,
      createdAt: new Date(),
      updatedAt: new Date(),
      user: uid,
    }

    const booking = await firebase
      .firestore()
      .collection( "bookings" )
      .add( booking_data )

    booking_data.id = booking.id
    return booking_data
  }
  catch ( error ) {
    console.error( 'add new booking', { error: error.message } )
  }
}

export const signUpNewUser = async ( firebase, { email, password, firstName, secondName } ) => {

  try {

    const firebaseUser = await firebase
      .auth()
      .createUserWithEmailAndPassword( email, password )

    await firebaseUser.user.updateProfile( {
      displayName: `${ firstName } ${ secondName }`,
    } )

    const firestoreUser = await firebase
      .firestore()
      .collection( "users" )
      .doc( firebaseUser.user.uid )

    return firestoreUser

  } catch ( error ) {
    console.error( 'add new user', { error: error.message } )
  }
}

export const getExistingUser = async ( firebase, uid ) => {
  try {

    const user = await firebase
      .firestore()
      .collection( "users" )
      .doc( uid )

    return user

  } catch ( error ) {
    console.error( 'get existing user', { error: error.message } )
  }
}

export const AddNewBooking = async ( firebase, values, cartData, locations, dateTimes, user, authUser ) => {

  const { email, firstName, secondName, jobReferenceNumber, phoneNumber } = values

  const isNewUser = ( !authUser || !localStorage.getItem( "isLoggedIn" ) )

  try {
    const firestoreUser = isNewUser
    ? await signUpNewUser( firebase, values )
    : await getExistingUser( firebase, authUser.uid )
    
    console.log( { firestoreUser } );
    const booking = await addNewBooking( firebase, firestoreUser?.id, cartData, locations, dateTimes, values )

    if ( isNewUser ) {
      await firestoreUser.set( {
        firstName: firstName,
        secondName: secondName,
        email: email,
        phoneNumber: phoneNumber,
        bookings: [ booking.id ],
      } )

      console.log( `Successfully created a new booking (${ jobReferenceNumber }) and assigned it to a new user (${ user.id })` )

    }

    if ( !isNewUser ) {
      user.bookings.push( booking.id )

      await firestoreUser
        .update( { bookings: user.bookings } )

      console.log( `Successfully created a new booking (${ booking.id }) and added it to ${ firestoreUser.email }` )

    }

    return {
      status: 200,
      booking,
      user,
    }

  } catch ( error ) {
    console.error( 'sign-up', { error: error.message } )
    return {
      status: 500,
      error
    }
  }
}

export default AddNewBooking